import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  section: {
    marginTop: theme.spacing(6)
  },
  recipient: {
    maxWidth: 260,
    overflowWrap: 'anywhere'
  },
  actions: {
    whiteSpace: 'nowrap',
    textAlign: 'right'
  },
  dialog: {
    maxWidth: 480
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(4)
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  }
}));
